import { useCallback, useState } from 'react'

import {
  claimPromoCode as claimPromoCodeApi,
  ClaimPromoCodeError,
  ClaimPromoCodeResponse,
} from '@api'

type UsePromoCodeClaimParams = {
  onSuccess?: (value?: ClaimPromoCodeResponse['data']) => void
}

export const usePromoCodeClaim = ({
  onSuccess,
}: UsePromoCodeClaimParams = {}) => {
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState<ClaimPromoCodeError | null>(null)
  const [success, setSuccess] = useState(false)

  const claimPromoCode = useCallback(async (code: string) => {
    setIsLoading(true)
    const response = await claimPromoCodeApi(code)
    if (response.ok) {
      setSuccess(true)
      onSuccess?.(response.data)
    } else {
      setError(response?.error || null)
    }
    setIsLoading(false)
  }, [])

  const resetError = useCallback(() => {
    setError(null)
  }, [])

  return { isLoading, error, success, claimPromoCode, resetError }
}
